const styles = (theme) => ({
  accordionRoot: {
    border: 'none',
    boxShadow: 'none',
  },
  accordionSummaryRoot: {
    padding: 0,
    userSelect: 'text',

    '&:hover:not(.Mui-disabled)': {
      cursor: 'initial'
    }
  },
  accordionSummaryExpanded: {
    minHeight: '48px !important',
    margin: '0 0 0 0 !important',
  },
  accordionSummaryContent: {
    margin: 0,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  accordionDetails: {
    padding: 0
  },
  accButtonIconEdgeEnd: {
    marginRight: '0 !important'
  },
  subCategoryName: {
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
  },
  linksCounter: {
    color: '#838A93',
    fontSize: 12,
    lineHeight: '26px',
  }
});

export default styles;